import React from 'react'

import { makeStyles } from '@material-ui/styles'
import { Card, CardContent, Typography } from '@material-ui/core'
import { Page } from 'components'
import { Logo } from 'components/Logo'
import { pxToRem } from 'utils/helpers'
import { Form } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: theme.breakpoints.values.sd,
    maxWidth: pxToRem(480),
    minWidth: pxToRem(480),
    overflow: 'unset',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%',
    },
  },
  content: {
    padding: theme.spacing(6, 4, 3, 4),
  },
  media: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(3),
    color: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    minHeight: 'fit-content',
  },
  form: {
    marginTop: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}))

export const ValidarDocumento = () => {
  const classes = useStyles()

  return (
    <Page className={classes.root} title="Validação de documentos">
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <div className={classes.profile}>
            <Logo />
            <Typography gutterBottom variant="h4">
              Validação de documentos
            </Typography>
          </div>
          <Form className={classes.form} />
        </CardContent>
      </Card>
    </Page>
  )
}
